import { createFileRoute } from '@tanstack/react-router';
import { NewsletterSetupReviewStep } from '@/pages/workspaces/broadcasts/newsletter/setup/review';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/review',
)({ component: withRumPageRendered(NewsletterSetupReviewStep) });
